/**
 * Lookbook Add to Cart Functionality
 * Fixed version - ensures only checked items are added
 */

document.addEventListener('DOMContentLoaded', function() {
    console.log('✅ Lookbook cart script loaded');
    
    // Function to create animated dots
    function createAnimatedText(button) {
        const originalText = button.textContent;
        let dotCount = 0;
        
        const interval = setInterval(() => {
            dotCount = (dotCount + 1) % 4;
            button.textContent = 'Adding' + '.'.repeat(dotCount);
        }, 300);
        
        return { interval, originalText };
    }
    
    // Function to add items to cart
    async function addItemsToCart(items) {
        console.log('Sending to cart:', JSON.stringify({ items: items }));
        
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ items: items })
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.description || 'Failed to add items');
        }
        
        return await response.json();
    }
    
    // Function to clear cart (for testing - optional)
    async function clearCart() {
        try {
            const response = await fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return await response.json();
        } catch (error) {
            console.error('Error clearing cart:', error);
        }
    }
    
    // Handle Add to Cart button
    const addToCartBtn = document.querySelector('.lookbook-add-to-cart');
    
    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', async function(e) {
            e.preventDefault();
            
            // Get ALL checkboxes first for debugging
            const allCheckboxes = document.querySelectorAll('.lookbook-checkbox');
            console.log('Total checkboxes:', allCheckboxes.length);
            
            // Get only CHECKED checkboxes
            const checkedCheckboxes = document.querySelectorAll('.lookbook-checkbox:checked');
            console.log('Checked checkboxes:', checkedCheckboxes.length);
            
            // Log each checkbox state for debugging
            allCheckboxes.forEach((cb, index) => {
                console.log(`Checkbox ${index}: checked=${cb.checked}, variantId=${cb.dataset.variantId}`);
            });
            
            if (checkedCheckboxes.length === 0) {
                alert('Please select at least one item');
                return;
            }
            
            // Build array of selected items from CHECKED checkboxes ONLY
            const selectedItems = [];
            const uniqueVariantIds = new Set();
            
            checkedCheckboxes.forEach((checkbox, index) => {
                const variantId = checkbox.dataset.variantId;
                
                if (variantId && variantId !== '' && variantId !== 'null') {
                    // Only add if we haven't seen this variant ID before
                    if (!uniqueVariantIds.has(variantId)) {
                        uniqueVariantIds.add(variantId);
                        selectedItems.push({
                            id: variantId,
                            quantity: 1
                        });
                        console.log(`Added checked item ${index}: variant ${variantId}`);
                    }
                }
            });
            
            console.log('Final selected items from checked checkboxes:', selectedItems);
            
            if (selectedItems.length === 0) {
                alert('Selected items are missing product information');
                return;
            }
            
            // Start animated dots
            this.disabled = true;
            const { interval, originalText } = createAnimatedText(this);
            
            try {
                // Add items to cart
                const result = await addItemsToCart(selectedItems);
                console.log('✅ Items added successfully:', result);
                
                // Clear animation and show success
                clearInterval(interval);
                this.textContent = '✓ Added!';
                
                // IMPORTANT: Uncheck only the checkboxes that WERE checked
                checkedCheckboxes.forEach(cb => {
                    cb.checked = false;
                    console.log('Unchecked checkbox for variant:', cb.dataset.variantId);
                });
                
                // Verify all checkboxes are now unchecked
                const afterUncheck = document.querySelectorAll('.lookbook-checkbox:checked');
                console.log('Checkboxes still checked after uncheck:', afterUncheck.length);
                
                // Update cart count in header
                fetch('/cart.js')
                    .then(r => r.json())
                    .then(cart => {
                        console.log('Cart updated with items:', cart);
                        const cartCount = document.querySelector('[data-cart-count], .cart-count, .header__cart-count, .hdt-cart-count');
                        if (cartCount) cartCount.textContent = cart.item_count;
                    });
                
                // Reset button after delay
                setTimeout(() => {
                    this.textContent = originalText;
                    this.disabled = false;
                }, 2000);
                
            } catch (error) {
                console.error('❌ Error adding items:', error);
                
                clearInterval(interval);
                this.textContent = '✗ Error';
                
                setTimeout(() => {
                    this.textContent = originalText;
                    this.disabled = false;
                }, 2000);
                
                alert(`Error adding items to cart: ${error.message}`);
            }
        });
    }
    
    // Add a test button to clear cart (optional - remove in production)
    // You can add a hidden button to help with testing
    const testClearBtn = document.createElement('button');
    testClearBtn.style.display = 'none';
    testClearBtn.id = 'clear-cart-test';
    testClearBtn.addEventListener('click', async () => {
        await clearCart();
        alert('Cart cleared');
    });
    document.body.appendChild(testClearBtn);
    
    console.log('✅ Lookbook cart script initialized');
});